/* TeleTunes Landing Page JS */
document.title = "Tele Tunes \u2014 Compact 3D-Printed Flutes";

// HERO VIDEO SOUND TOGGLE
const video = document.getElementById('tt-hero-video');
const soundBtn = document.getElementById('tt-soundBtn');
const soundIcon = document.getElementById('tt-soundIcon');

if (soundBtn && video) {
  soundBtn.addEventListener('click', () => {
    video.muted = !video.muted;
    soundIcon.textContent = video.muted ? '🔇' : '🔊';
    soundBtn.querySelector('.tt-sound-label').textContent = video.muted ? 'Play sound' : 'Mute';
  });
}

// SHOP DROPDOWN + MOBILE MENU — handled by inline script in nav

// AUDIO PLAYER
let currentAudio = null;
let currentPlayBtn = null;

document.querySelectorAll('.tt-play-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const src = btn.dataset.src;

    if (currentAudio && !currentAudio.paused) {
      currentAudio.pause();
      currentAudio.currentTime = 0;
      currentPlayBtn.querySelector('.tt-play-icon').textContent = '▶';
      if (currentPlayBtn === btn) {
        currentAudio = null; currentPlayBtn = null;
        return;
      }
    }

    const audio = new Audio(src);
    audio.play().catch(() => console.log('Audio demo file not found:', src));
    btn.querySelector('.tt-play-icon').textContent = '⏸';

    audio.addEventListener('ended', () => {
      btn.querySelector('.tt-play-icon').textContent = '▶';
      currentAudio = null; currentPlayBtn = null;
    });

    currentAudio = audio;
    currentPlayBtn = btn;
  });
});

// VIDEO UNMUTE BUTTONS — handled by inline script in teletunes-landing.liquid
// (SVG icon toggle, not emoji — do not add emoji overrides here)

// FAQ — close others on open
document.querySelectorAll('.tt-faq-item').forEach(item => {
  item.addEventListener('toggle', () => {
    if (item.open) {
      document.querySelectorAll('.tt-faq-item[open]').forEach(other => {
        if (other !== item) other.removeAttribute('open');
      });
    }
  });
});

// NAV — darker on scroll
const nav = document.querySelector('.tt-nav');
if (nav) {
  window.addEventListener('scroll', () => {
    nav.style.background = window.scrollY > 60
      ? 'rgba(17,14,11,0.97)'
      : 'rgba(26,20,16,0.85)';
  }, { passive: true });
}

// SCROLL REVEAL — bidirectional with varied movement
// Assign initial hidden state per element type
function getHiddenTransform(el) {
  if (el.classList.contains('tt-why-image'))  return 'translateX(-48px) scale(0.97)';
  if (el.classList.contains('tt-why-text'))   return 'translateX(48px)';
  if (el.classList.contains('tt-product-card') || el.classList.contains('tt-audio-card') || el.classList.contains('tt-review-card')) {
    return 'translateY(36px) scale(0.95)';
  }
  if (el.classList.contains('tt-section-title')) return 'translateY(18px)';
  if (el.classList.contains('tt-stars-bar'))      return 'translateY(14px)';
  return 'translateY(28px)';
}

const revealEls = document.querySelectorAll(
  '.tt-audio-card, .tt-product-card, .tt-review-card, .tt-why-list li, .tt-faq-item, ' +
  '.tt-section-title, .tt-section-sub, .tt-stars-bar, ' +
  '.tt-why-image, .tt-why-text, .tt-bundle-box, .tt-email-container'
);

// Stagger delay map (assigned once, persists)
const delayMap = new WeakMap();

revealEls.forEach(el => {
  const hiddenTransform = getHiddenTransform(el);
  el.dataset.hiddenTransform = hiddenTransform;
  el.style.opacity = '0';
  el.style.transform = hiddenTransform;
  el.style.transition = 'opacity 0.55s cubic-bezier(0.22,0.61,0.36,1), transform 0.55s cubic-bezier(0.22,0.61,0.36,1)';
  delayMap.set(el, 0);
});

// Stagger cards within their parent grids (set delay once)
document.querySelectorAll('.tt-products-grid, .tt-audio-grid, .tt-reviews-grid').forEach(grid => {
  grid.querySelectorAll(':scope > .tt-product-card, :scope > .tt-audio-card, :scope > .tt-review-card').forEach((card, i) => {
    delayMap.set(card, i * 0.08);
  });
});

// One-shot observer — reveal once, then stop observing so scroll never dims the element
const observer = new IntersectionObserver((entries, obs) => {
  entries.forEach(e => {
    if (!e.isIntersecting) return;
    const delay = delayMap.get(e.target) || 0;
    e.target.style.transitionDelay = `${delay}s`;
    e.target.style.opacity = '1';
    e.target.style.transform = 'translateY(0) translateX(0) scale(1)';
    obs.unobserve(e.target);
  });
}, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

revealEls.forEach(el => observer.observe(el));

// QUICK ADD on product cards
document.querySelectorAll('.tt-quick-add').forEach(btn => {
  btn.addEventListener('click', async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const variantId = btn.dataset.variantId;
    const hasOptions = btn.dataset.hasOptions === '1';
    const productUrl = btn.dataset.productUrl;
    if (hasOptions || !variantId) {
      window.location.href = productUrl;
      return;
    }
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
      });
      if (!res.ok) throw new Error('add failed');
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      const plus = btn.querySelector('.tt-cart-plus');
      if (plus) plus.textContent = '✓';
      document.dispatchEvent(new CustomEvent('tt:cart-added', { detail: { source: btn } }));
      window.setTimeout(() => {
        btn.classList.remove('is-added');
        if (plus) plus.textContent = '+';
      }, 1800);
    } catch (err) {
      btn.classList.remove('is-loading');
      document.dispatchEvent(new CustomEvent('tt:cart-add-error'));
    } finally {
      btn.disabled = false;
    }
  });
});
